import { ContributorJobsState, StoreAction } from "../../models/rootState.model";
import * as fromActions from '../actions/contributor-jobs.actions';


const InitialState: ContributorJobsState = {
    jobs: null,
    loaded: false,
    loading: false,
    error: ''
}

export function JobsReducer(
    state = InitialState,
    action: StoreAction
): ContributorJobsState {
    switch (action.type) {

        case fromActions.JOBS_ACTION_TYPES.LOAD: {
            return {
                ...state,
                error: null,
                loading: true
            }
        }

        case fromActions.JOBS_ACTION_TYPES.LOADED: {
            return {
                ...state,
                loaded: true,
                loading: false,
                error: null,
                jobs: action.payload
            }
        }

        case fromActions.JOBS_ACTION_TYPES.LOADED: {
            return {
                ...state,
                loaded: false,
                loading: false,
                error: action.payload
            }
        }

        default: { return state}
    }

}